// extracted by mini-css-extract-plugin
export default {"modalContainer":"_87567fd4","buttonContainer":"_89503be9"};